import React from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import { formatNull } from '../Utils/GlobalUtils';

import FileUploadField from '../Components/FileUploadField';

import CaseDebtors from './CaseComponents/CaseDebtors';

import Loading from '../Components/Loading';
import WarningPanel from './WarningPanel';

import styles from '../styles/DynamicModal.module.css';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';

export default function AddNewDocumentToApplication({ applicationId, caseId=null, isFirst=true, closeModal, onSuccess }) {
    const { openTimeModal } = useTimeModal();
    const location = useLocation();
    const navigate = useNavigate();

    const [status, setStatus] = React.useState('');
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState('');
    const [formInfo, setFormInfo] = React.useState({});
    const [loading, setLoading] = React.useState(false);

    const [typeOfNewDoc, setTypeOfNewDoc] = React.useState('appointmentAMAgreement');

    React.useEffect(() => {
        if (!caseId) return;

        const token = localStorage.getItem('token');
        setLoading(true);

        axios.get(`/api/get-open-info-case?id=${caseId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then((response) => {
            setWarning('');
            setFormInfo((prev) => ({
                ...prev,
                ...response.data,
            }));
        })
        .catch((error) => {
            if (error.response?.data.action == 'logout') window.location.href = '/auth/logout';
            setFormInfo([]);
            setWarning(`${error.response?.data.message || 'Не удалось загрузить проверочные данные карточки заявки. Попробуйте позже или прикрепите согласие сейчас, сверив данные вручную по таблице'}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        });
    }, [caseId, reload]);

    const handleSave = () => {
        setLoading(true);

        if (!files.new_doc) {
            setStatus(<a className='mainLabelError'>Прикрепите файл</a>);
            return setLoading(false);
        };

        const formData = new FormData();
        formData.append('typeOfDoc', typeOfNewDoc);
        formData.append('application_id', applicationId);
        formData.append('file_new_doc', files.new_doc);

        axios.put('/api/add-new-application-file', formData, {
            headers: { 
                'Content-Type': 'multipart/form-data',
            },
        }).then(() => {
            onSuccess();
            closeModal();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Файл не отправлен. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        });
    }
    
    
    const [files, setFiles] = React.useState({
        new_doc: null,
    });
    const handleFileChange = (field) => (e) => {
        const file = e.target.files[0];
        setFiles((prev) => ({
            ...prev,
            [field]: file || null,
        }));
    };

    const handleFileReset = (field) => () => {
        setFiles((prev) => ({
            ...prev,
            [field]: null,
        }));
    };

    const [userId, setUserId] = React.useState('');

    React.useEffect(() => {
        const token = localStorage.getItem('token');
    
        try {
            const decodedToken = jwtDecode(token);
            setUserId(decodedToken.id);
        } catch (error) {
            console.error('Ошибка при декодировании токена: ', error);
        }
    }, []);

    const [isLoadingButton, setIsLoadingButton] = React.useState(null);

    const handleDownloadAgreementWithAutoData = async (typeOfFile = 'docx') => {
        if (isDisabledButtonFile) return;
        setIsDisabledButtonFile(true);
        if (typeOfFile=='pdf') setIsLoadingButton('pdf');
        if (typeOfFile=='docx') setIsLoadingButton('docx');
        if (!caseId) return setWarning('Произошла неизвестная ошибка. Нет дела для формирования согласия');
        if (!userId) return setWarning('Произошла неизвестная ошибка. Нет пользователя для формирования согласия');
        try {
            const res = await fetch(`/api/sign-appointment-am-agreement?user_id=${userId}&case_id=${caseId}&type_of_file=${typeOfFile}`, {
                method: "GET",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });

            if (!res.ok) {
                let errorMessage = 'Произошла неизвестная ошибка. Попробуйте повторить позднее';
                try {
                    const errorData = await res.json();
                    errorMessage = errorData.message || errorMessage;
                } catch {
                    // тело не JSON, оставляем дефолтное сообщение
                }
                throw new Error(errorMessage);
            }

            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `Согласие_на_назначение.${typeOfFile}`;
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);
        } catch (err) {
            openTimeModal(err.message, 'error');
            console.error("Ошибка при скачивании файла:", err);
        }
        setTimeout(() => {
            setIsDisabledButtonFile(false);
            setIsLoadingButton('');
        }, 3000);
    };
    const handleDownloadRefusalWithAutoData = async (typeOfFile = 'docx') => {
        if (isDisabledButtonFile) return;
        setIsDisabledButtonFile(true);
        if (typeOfFile=='pdf') setIsLoadingButton('pdf');
        if (typeOfFile=='docx') setIsLoadingButton('docx');
        if (!caseId) return setWarning('Произошла неизвестная ошибка. Нет дела для формирования согласия');
        if (!userId) return setWarning('Произошла неизвестная ошибка. Нет пользователя для формирования согласия');
        try {
            const res = await fetch(`/api/sign-appointment-am-refusal?user_id=${userId}&case_id=${caseId}&type_of_file=${typeOfFile}`, {
                method: "GET",
                headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });

            if (!res.ok) {
                throw new Error("Ошибка при скачивании");
            }

            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `Отзыв_согласия.${typeOfFile}`; // имя файла при скачивании
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);
        } catch (err) {
            openTimeModal(`${err.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
            console.error("Ошибка при скачивании файла:", err);
        }
        setTimeout(() => {
            setIsDisabledButtonFile(false);
            setIsLoadingButton('');
        }, 3000);
    };

    const [isDisabledButtonFile, setIsDisabledButtonFile] = React.useState(false);

    return (
        <div className={styles.liningOver} style={{zIndex: '20'}} onClick={() => {closeModal();}}>
            <div className={styles.lining} onClick={(e) => {e.stopPropagation()}}>
                <div className={styles.header}>
                    <h1>
                        {isFirst ? 
                        'Прикрепить согласие'
                        :
                        'Прикрепить новый документ к заявке'}
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    {loading ? <Loading />
                    :
                    <>
                    <h3 className='formHeadline'>Проверьте данные дела</h3>
                    <div className='labelInputWrapper'>
                        <a className='label'>Номер дела</a>
                        <div className='labelInputRight'>
                            <a>{formatNull(formInfo.number)}</a>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Ссылка</a>
                        <div className='labelInputRight'>
                            <a>
                                {formInfo.case_link ?
                                <a 
                                    className='aWithLink' 
                                    href={formInfo.case_link}
                                    target="_blank"
                                >
                                    {formatNull(formInfo.case_link)}
                                </a>
                                :
                                <a className='description'>
                                    Отсутствует
                                </a>}
                            </a>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Арбитражный суд</a>
                        <div className='labelInputRight'>
                            <a>{formatNull(formInfo.court_name)}</a>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Должники</a>
                        <div className='labelInputRight'>
                            <CaseDebtors
                                caseId={caseId}
                                debtors_ids={formInfo.debtors || []}
                                reload={reload}
                                onSuccess={() => setReload(true)}
                                formInfo={formInfo} 
                                setFormInfo={setFormInfo}
                                isShowButtons={false}
                            />
                        </div>
                    </div>

                    <span className='horizontalLine'></span>

                    <h3 className='formHeadline'>Загрузите документ</h3>
                    {!isFirst &&
                    <div className='labelInputWrapper'>
                        <a className='label'>Тип документа к заявке</a>
                        <div className='labelInputRight'>
                            <div className='radioSwitchWrapper'>
                                <label className={`radioSwitchLabel ${typeOfNewDoc === 'appointmentAMAgreement' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='appointmentAMAgreement'
                                        checked={typeOfNewDoc === 'appointmentAMAgreement'}
                                        onChange={() => setTypeOfNewDoc('appointmentAMAgreement')}
                                    />
                                    <span>Согласие на назначение</span>
                                </label>
                                <label className={`radioSwitchLabel ${typeOfNewDoc === 'appointmentAMRefusal' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='appointmentAMRefusal'
                                        checked={typeOfNewDoc === 'appointmentAMRefusal'}
                                        onChange={() => setTypeOfNewDoc('appointmentAMRefusal')}
                                    />
                                    <span>Отзыв согласия на назначение</span>
                                </label>
                            </div>
                        </div>
                    </div>}
                    <div className='labelInputWrapper'>
                        <a className='label'>Документ</a>
                        <div className='labelInputRight'>
                            <FileUploadField
                                label='Прикрепить файл'
                                file={files.new_doc}
                                buttonLabel='Прикрепить файл'
                                onChange={handleFileChange('new_doc')}
                                onReset={handleFileReset('new_doc')}
                                allowedFileTypes={['pdf', 'docx', 'doc']}
                            />
                            <div style={{height: '20px'}}></div>
                            {typeOfNewDoc=='appointmentAMAgreement' &&
                            <div className='panel'>
                                <p className='description'>Автоматически сформировать согласие</p>
                                <button 
                                    type='button' 
                                    className='button miniButton' 
                                    onClick={() => handleDownloadAgreementWithAutoData('pdf')}
                                    disabled={isDisabledButtonFile}
                                >
                                    {isLoadingButton=='pdf' ? 
                                    <>Загрузка... <Loading type='inline' /></>
                                    :
                                    'Скачать сформированное согласие в pdf'}
                                </button>
                                <button 
                                    type='button' 
                                    className='button miniButton' 
                                    onClick={() => handleDownloadAgreementWithAutoData('docx')}
                                    disabled={isDisabledButtonFile}
                                >
                                    {isLoadingButton=='docx' ? 
                                    <>Загрузка... <Loading type='inline' /></>
                                    :
                                    'Скачать сформированное согласие в docx'}
                                </button>
                            </div>}
                            {typeOfNewDoc=='appointmentAMRefusal' &&
                            <div className='panel'>
                                <p className='description'>Автоматически сформировать отзыв</p>
                                <button 
                                    type='button' 
                                    className='button miniButton' 
                                    onClick={() => handleDownloadRefusalWithAutoData('pdf')}
                                    disabled={isDisabledButtonFile}
                                >
                                    {isLoadingButton=='pdf' ? 
                                    <>Загрузка... <Loading type='inline' /></>
                                    :
                                    'Скачать сформированный отзыв в pdf'}
                                </button>
                                <button 
                                    type='button' 
                                    className='button miniButton' 
                                    onClick={() => handleDownloadRefusalWithAutoData('docx')}
                                    disabled={isDisabledButtonFile}
                                >
                                    {isLoadingButton=='docx' ? 
                                    <>Загрузка... <Loading type='inline' /></>
                                    :
                                    'Скачать сформированный отзыв в docx'}
                                </button>
                            </div>}
                        </div>
                    </div>
                    </>}
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        Отправить документ
                    </button>
                </div>
            </div>
        </div>
    )
}
